module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img17.4d2c199f.jpg";